"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getImageUrl = function getImageUrl(url, width) {
  var widthParam = width ? ",w_".concat(width) : '';
  return "https://img.gymshark.com/image/fetch/q_auto,f_auto".concat(widthParam, "/").concat(/^((http|https):\/\/)/.test(url) ? url : "https:".concat(url));
};

var _default = getImageUrl;
exports["default"] = _default;